<script lang="ts">
  // The brand logo mark: the generated Tane sprout icon (the same art as the
  // favicon / app icon), rendered as a rounded tile. Used in the header
  // (top-left) and the footer. (The botanical Sprout motif still appears
  // throughout the page as the growth illustration.)
  let { size = 36 }: { size?: number } = $props();
</script>

<img
  class="seal"
  src="/icon-192.png"
  alt=""
  aria-hidden="true"
  width={size}
  height={size}
  style="width:{size}px;height:{size}px"
/>

<style>
  .seal {
    flex: none;
    display: block;
    object-fit: cover;
    border-radius: 28%;
    user-select: none;
    box-shadow:
      0 0 0 1px rgba(23, 39, 29, 0.06),
      0 4px 12px -6px rgba(30, 77, 51, 0.5);
    transition: transform 0.5s var(--ease);
  }
</style>
